import axios from "axios";

const authConfig = (token) => ({
  headers: { "x-auth-token": token },
});

export const createSavedSearch = async (params, token) => {
  const res = await axios.post("/api/saved-searches", params, authConfig(token));
  return res.data;
};

export const fetchMySavedSearches = async (token) => {
  const res = await axios.get("/api/saved-searches/mine", authConfig(token));
  return res.data;
};

export const fetchSavedSearchBySlug = async (slug, token) => {
  const config = token ? authConfig(token) : {};
  const res = await axios.get(`/api/saved-searches/slug/${slug}`, config);
  return res.data;
};

export const fetchSavedSearchResults = async (slug, token) => {
  const config = token ? authConfig(token) : {};
  const res = await axios.get(`/api/saved-searches/slug/${slug}/results`, config);
  return res.data;
};

export const updateSavedSearchApi = async (id, updates, token) => {
  const res = await axios.put(`/api/saved-searches/${id}`, updates, authConfig(token));
  return res.data;
};

export const deleteSavedSearchApi = async (id, token) => {
  const res = await axios.delete(`/api/saved-searches/${id}`, authConfig(token));
  return res.data;
};

export const addRestaurantToList = async (listId, restaurantId, token) => {
  const res = await axios.post(
    `/api/saved-searches/${listId}/restaurants`,
    { restaurantId },
    authConfig(token)
  );
  return res.data;
};

export const removeRestaurantFromList = async (listId, restaurantId, token) => {
  const res = await axios.delete(
    `/api/saved-searches/${listId}/restaurants/${restaurantId}`,
    authConfig(token)
  );
  return res.data;
};

export const fetchExploreLists = async ({ lat, lng, radius, limit } = {}) => {
  const params = new URLSearchParams();
  if (lat) params.set("lat", lat);
  if (lng) params.set("lng", lng);
  if (radius) params.set("radius", radius);
  if (limit) params.set("limit", limit);
  const res = await axios.get(`/api/saved-searches/explore?${params.toString()}`);
  return res.data;
};
